export default {
  main: '#57267C',
  secondary: '#f49525',
  contrastingColor: '#ffffff',
  priceColor: '#BA0C2F',
  entryBackground: '#57267C',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
